import type { StartAppListening } from '@/store/listenerMiddleware.ts';
import { changeClient } from '@/store/tabs/slice.ts';
import { targetAccumulatorSlice } from '@/store/targetAccumulator/slice.ts';
import { selectTileClientId } from '@/store/tiles/selectors.ts';

export const registerChangeClientListenerForTargetAccumulator = (startAppListening: StartAppListening) => {
  startAppListening({
    actionCreator: changeClient,
    effect: (action, api) => {
      const currentState = api.getState();
      const previousState = api.getOriginalState();

      for (const { tileId } of targetAccumulatorSlice.selectors.getAllTargetAccumulatorProducts(currentState)) {
        if (currentState.tiles.entities[tileId]?.tabId !== action.payload.tabId) {
          continue;
        }

        const previousClientId = selectTileClientId(previousState, tileId);
        const currentClientId = selectTileClientId(currentState, tileId);
        if (previousClientId === currentClientId) {
          continue;
        }

        api.dispatch(
          targetAccumulatorSlice.actions.targetAccumulatorClientIdUpdated({
            tileId,
            clientId: currentClientId,
            isTabClientOverriden: false,
          }),
        );
      }
    },
  });
};
